module.exports = __webpack_public_path__ + "static/frontUserNew/img/professional-01.7ddc18d5.png";